import { ITiers, TTierCommission } from "../../../../types/spiffSetup";

export const getInputToUse = (tiers: ITiers[] = [], index = 0) =>
	tiers?.[index]?.["commissions"]?.[0]?.["commission"]?.["input"] || "Dollar";

export const getLastIndex = (tiers: TTierCommission[] = [], type = "length", defaultValue = 0) => {
	if (type === "length") {
		return tiers?.length ? tiers.length - 1 : defaultValue;
	}
	return tiers?.[0]?.["commissions"]?.length ? tiers[0]["commissions"].length - 1 : defaultValue;
};

export const defaultCommissionTier = (from = 0, to = 0, definition = { commission: 0, input: "Dollar" }) => ({
	from: defaultInput(from, "Dollar"),
	to: defaultInput(to, "Dollar"),
	commission: defaultInput(definition.commission, definition.input),
});
export const defaultInput = (value = 0, input = "Unit") => ({ value, input });

export const validateLastCommissionHighest = (data: ITiers[]) => {
	// Flatten all commission values from the matrix
	const allCommissionValues = data.flatMap((item) => item.commissions.map((commissionObj) => commissionObj.commission.value));

	// Check for single-level matrix case
	if (allCommissionValues.length === 1) {
		return allCommissionValues[0] !== 0;
	}

	// For multi-level matrix, get the last commission value
	const lastCommissionValue = allCommissionValues[allCommissionValues.length - 1];

	// Ensure that at least one commission value is less than the last value
	const hasSmallerValue = allCommissionValues.slice(0, -1).some((value) => value < lastCommissionValue);

	// Ensure no values are greater than the last value
	const allOtherValuesAreNotGreater = allCommissionValues.slice(0, -1).every((value) => value <= lastCommissionValue);

	// Both conditions must be true
	return hasSmallerValue && allOtherValuesAreNotGreater;
};

export const isTiersMatrixValid = (data: ITiers[]) => {
	if (data?.length === 0 || !data[0].commissions) {
		return false;
	}
	const isDollarUnity = data[0].commissions[0].commission.input === "Dollar";
	if (isDollarUnity && data?.length <= 1 && data[0]?.commissions?.length <= 1) {
		return false;
	}

	if (!isDollarUnity && data?.length < 1 && data[0]?.commissions?.length < 1) {
		return false;
	}

	return true;
};
